/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide the known part by the percentage expressed as a decimal. For example, if 18 is 30% of a number, divide 18 by 0.3 to get 60. This 'reverse percentage' is the same formula the third calculator mode uses, just isolating a different variable.`)
};

const es_pct_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide la parte conocida entre el porcentaje expresado como decimal. Por ejemplo, si 18 es el 30% de un número, divide 18 entre 0,3 para obtener 60. Este 'porcentaje inverso' usa la misma fórmula que el tercer modo de la calculadora, solo que despejando una variable distinta.`)
};

const de_pct_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile den bekannten Teil durch den Prozentsatz, ausgedrückt als Dezimalzahl. Wenn zum Beispiel 18 gleich 30% einer Zahl sind, teile 18 durch 0.3, um 60 zu erhalten. Diese „umgekehrte Prozentrechnung“ nutzt dieselbe Formel wie der dritte Rechner-Modus, nur mit einer anderen isolierten Variablen.`)
};

const nl_pct_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deel het bekende deel door het percentage uitgedrukt als decimaal getal. Als 18 bijvoorbeeld 30% van een getal is, deel je 18 door 0.3 om 60 te krijgen. Dit 'omgekeerde percentage' gebruikt dezelfde formule als de derde calculatormodus, maar isoleert een andere variabele.`)
};

const fr_pct_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisez la partie connue par le pourcentage exprimé en décimale. Par exemple, si 18 représente 30 % d’un nombre, divisez 18 par 0,3 pour obtenir 60. Ce « pourcentage inversé » utilise la même formule que le troisième mode du calculateur, en isolant simplement une autre variable.`)
};

const it_pct_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi la parte nota per la percentuale espressa come decimale. Ad esempio, se 18 è il 30% di un numero, dividi 18 per 0.3 per ottenere 60. Questa 'percentuale inversa' è la stessa formula usata dalla terza modalità del calcolatore, semplicemente isolando una variabile diversa.`)
};

const pt_br2_pct_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida a parte conhecida pela porcentagem expressa como decimal. Por exemplo, se 18 é 30% de um número, divida 18 por 0.3 para obter 60. Essa 'porcentagem reversa' é a mesma fórmula que o terceiro modo da calculadora usa, apenas isolando uma variável diferente.`)
};

const pt_pct_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida a parte conhecida pela percentagem expressa como decimal. Por exemplo, se 18 é 30% de um número, divida 18 por 0.3 para obter 60. Esta "percentagem inversa" é a mesma fórmula usada no terceiro modo da calculadora, apenas a isolar uma variável diferente.`)
};

const ja_pct_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分かっている部分の値を、小数で表したパーセントで割ります。例えば18がある数の30%であれば、18を0.3で割ると60が求まります。この「パーセントの逆算」は、3つ目の計算モードと同じ式で、求める変数が異なるだけです。`)
};

const zh_pct_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用已知的部分除以化为小数的百分比。例如，如果 18 是某个数的 30%，用 18 除以 0.3 得到 60。这种“反向百分比”用的正是第三种计算器模式的公式，只是求解的变量不同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_hub_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_hub_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_hub_faq3_a", locale)
	if (locale === "en") return en_pct_hub_faq3_a(inputs)
	if (locale === "es") return es_pct_hub_faq3_a(inputs)
	if (locale === "de") return de_pct_hub_faq3_a(inputs)
	if (locale === "nl") return nl_pct_hub_faq3_a(inputs)
	if (locale === "fr") return fr_pct_hub_faq3_a(inputs)
	if (locale === "it") return it_pct_hub_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_hub_faq3_a(inputs)
	if (locale === "pt") return pt_pct_hub_faq3_a(inputs)
	if (locale === "ja") return ja_pct_hub_faq3_a(inputs)
	return zh_pct_hub_faq3_a(inputs)
};